export function AmbientBackground() {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed inset-0 -z-10 overflow-hidden"
      style={{
        background: 'linear-gradient(180deg, rgb(242,240,237), rgb(249,248,246))',
      }}
    >
      <div
        className="absolute"
        style={{
          top: '-360px',
          left: '-360px',
          width: '1440px',
          height: '1440px',
          background:
            'radial-gradient(circle, rgba(175,130,96,0.22), rgba(0,0,0,0) 70%)',
          filter: 'blur(100px)',
        }}
      />
      <div
        className="absolute"
        style={{
          top: '-336px',
          right: '-336px',
          width: '1336px',
          height: '1336px',
          background:
            'radial-gradient(circle, rgba(36,39,229,0.14), rgba(0,0,0,0) 70%)',
          filter: 'blur(100px)',
        }}
      />
      <div
        className="absolute"
        style={{
          bottom: '-282px',
          left: '50%',
          transform: 'translateX(-50%)',
          width: '1130px',
          height: '1130px',
          background:
            'radial-gradient(circle, rgba(43,43,59,0.09), rgba(0,0,0,0) 70%)',
          filter: 'blur(100px)',
        }}
      />
    </div>
  );
}
